/* eslint sort-keys: 'error' */
export default {
  /* german */
  de: {
    'finance': 'Finanz | Finanzen',
    'finances_expenses': 'Ausgaben:',
    'finances_full_year': 'ganzes Jahr',
    'finances_month_abbr_april': 'Apr',
    'finances_month_abbr_august': 'Aug',
    'finances_month_abbr_december': 'Dez',
    'finances_month_abbr_february': 'Feb',
    'finances_month_abbr_january': 'Jan',
    'finances_month_abbr_july': 'Juli',
    'finances_month_abbr_june': 'Juni',
    'finances_month_abbr_march': 'März',
    'finances_month_abbr_may': 'Mai',
    'finances_month_abbr_november': 'Nov',
    'finances_month_abbr_october': 'Okt',
    'finances_month_abbr_september': 'Sep',
    'finances_month_april': 'April',
    'finances_month_august': 'August',
    'finances_month_december': 'Dezember',
    'finances_month_february': 'Februar',
    'finances_month_january': 'Januar',
    'finances_month_july': 'Juli',
    'finances_month_june': 'Juni',
    'finances_month_march': 'März',
    'finances_month_may': 'Mai',
    'finances_month_november': 'November',
    'finances_month_october': 'Oktober',
    'finances_month_september': 'September',
    'finances_monthly': 'Monatlich',
    'finances_overview': 'Übersicht',
    'finances_quarters_abbr_apr_jun': 'Apr - Juni',
    'finances_quarters_abbr_jan_mar': 'Jan - März',
    'finances_quarters_abbr_jul_sep': 'Juli - Sep',
    'finances_quarters_abbr_oct_dec': 'Okt - Dez',
    'finances_quarters_apr_jun': 'April bis Juni',
    'finances_quarters_jan_mar': 'Januar bis März',
    'finances_quarters_jul_sep': 'Juli bis September',
    'finances_quarters_oct_dec': 'Oktober bis Dezember',
    'finances_quaterly': 'Quartalsweise',
    'finances_revenues': 'Umsätze:',
    'finances_time_span': 'Zeitspanne',
    'finances_year': 'Jahr',
    'finances_yearly': 'Jährlich'
  },

  /* english */
  en: {
    'finance': 'Finance | Finances',
    'finances_expenses': 'Expenses:',
    'finances_full_year': 'full year',
    'finances_month_abbr_april': 'Apr',
    'finances_month_abbr_august': 'Aug',
    'finances_month_abbr_december': 'Dec',
    'finances_month_abbr_february': 'Feb',
    'finances_month_abbr_january': 'Jan',
    'finances_month_abbr_july': 'July',
    'finances_month_abbr_june': 'June',
    'finances_month_abbr_march': 'Mar',
    'finances_month_abbr_may': 'May',
    'finances_month_abbr_november': 'Nov',
    'finances_month_abbr_october': 'Oct',
    'finances_month_abbr_september': 'Sep',
    'finances_month_april': 'April',
    'finances_month_august': 'August',
    'finances_month_december': 'December',
    'finances_month_february': 'February',
    'finances_month_january': 'January',
    'finances_month_july': 'July',
    'finances_month_june': 'June',
    'finances_month_march': 'March',
    'finances_month_may': 'May',
    'finances_month_november': 'November',
    'finances_month_october': 'October',
    'finances_month_september': 'September',
    'finances_monthly': 'monthly',
    'finances_overview': 'Overview',
    'finances_quarters_abbr_apr_jun': 'Apr - June',
    'finances_quarters_abbr_jan_mar': 'Jan - Mar',
    'finances_quarters_abbr_jul_sep': 'July - Sep',
    'finances_quarters_abbr_oct_dec': 'Oct - Dec',
    'finances_quarters_apr_jun': 'April until June',
    'finances_quarters_jan_mar': 'January until March',
    'finances_quarters_jul_sep': 'July until September',
    'finances_quarters_oct_dec': 'October until December',
    'finances_quaterly': 'quaterly',
    'finances_revenues': 'Revenues:',
    'finances_time_span': 'Time Span',
    'finances_year': 'Year',
    'finances_yearly': 'yearly'
  }
}
